import AgreementItem from './AgreementItem';

export default AgreementItem;
